import PortModel from '../PortModel';

import { AbstractModelFactory } from '@projectstorm/react-canvas-core';

export default class PortFactory extends AbstractModelFactory {
  constructor() {
    super("NG_INSIGHT_DIAGRAM_PORT");
  }

  generateModel = ({ name, input }) =>
    new PortModel({
      name,
      input
    });
}
